module.exports = "/static/assets/aaa4a3575852fe11d04f44c4a972ae73.svg";